/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  
  $('.deal-upgrade-gold').click(function() {
    return $.setDefaultPaymentPageTier('gold');
  });

  return $('.deal-upgrade-silver').click(function() {
    return $.setDefaultPaymentPageTier('silver');
  });
});